
export enum PaymentStatus {
        WaitingConfirm          = 1,
        Paid                    = 2,
        NotAccepted             = 3,
        IsRefundInProcess       = 4,
        IsRefundFinished        = 5,
        DeclineRefund           = 6,
        RequestForFundsTransfer = 7,
        FundsTransfered         = 8
}

export var PaymentStatusDescription: { [key: PaymentStatus]: string; } = {};
PaymentStatusDescription[PaymentStatus.WaitingConfirm]          = "Ожидает подтверждения";
PaymentStatusDescription[PaymentStatus.Paid]                    = "Оплачено";
PaymentStatusDescription[PaymentStatus.NotAccepted]             = "Платёж не принят";
PaymentStatusDescription[PaymentStatus.IsRefundInProcess]        = "В процессе возврата";
PaymentStatusDescription[PaymentStatus.IsRefundFinished]        = "Возврат завершён";
PaymentStatusDescription[PaymentStatus.DeclineRefund]           = "Отказ на возврат средств";
PaymentStatusDescription[PaymentStatus.RequestForFundsTransfer] = "Запрос на перечисление средств";
PaymentStatusDescription[PaymentStatus.FundsTransfered]         = "Деньги перечислены продавцу";